import AddressDelete from "../typescript/modules/address-delete";
import AddressLookup from "../typescript/modules/address-lookup";
import CharacterCounter from "../typescript/modules/character-counter";

if (document.querySelector('.js-address-lookup')) {
	new AddressLookup();
}

const characterCounters = document.querySelectorAll('.js-character-counter') as NodeListOf<HTMLElement>;
for (let i = 0; i < characterCounters.length; i++) {
	new CharacterCounter(characterCounters[i]);
}
const deleteButtons = document.querySelectorAll('.js-delete-address') as NodeListOf<HTMLButtonElement>;
for (let i = 0; i < deleteButtons.length; i++) {
	new AddressDelete(deleteButtons[i]);
}
